export default "__VITE_ASSET__GYOPY2X___"